import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import SearchResultPage from './searchresultpage/searchresultpage';

function hydrateSearchResultPage() {
    if (typeof window.__PRELOADED_SEARCH_RESULT_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_SEARCH_RESULT_PAGE_STATE__));
        delete window.__PRELOADED_SEARCH_RESULT_PAGE_STATE__;
        hydrateRoot(
            document.getElementById('ats_searchresultpage'),
            <SearchResultPage {...data} suppressHydrationWarning={true} />,
        );
    }
}

hydrateSearchResultPage();
